import { modifiers } from "ui-tools"
import { JourneyThumbnail } from "../JourneyThumbnail"
import s from "./YourJourneysList.module.scss"

export const YourJourneysListSkeleton = () => {
  return (
    <div className={s.journeyList}>
      <SkeletonItem showConnector />
      <SkeletonItem showConnector />
      <SkeletonItem showConnector />
      <SkeletonItem showConnector />
      <SkeletonItem />
    </div>
  )
}

type SkeletonItemProps = { showConnector?: boolean }
const SkeletonItem = ({ showConnector = false }: SkeletonItemProps) => (
  <div className={s.journeyItem}>
    <div className={s.journeyItem__row}>
      <div className={modifiers(s, "journeyItem__button", { skeleton: true })}>
        <div className={s.journeyItem__thumbnailColumn}>
          <JourneyThumbnail variant="default" />
        </div>
        <div className={s.skeleton__journeyItemTitle} />
      </div>
    </div>

    {showConnector && <div className={s.journeyItem__connector} />}
  </div>
)
